import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { environment } from "../environment";

const isTactical = environment.VITE_ENV_TYPE === "tactical";

export const cioAnalytics =
  !isTactical && environment.VITE_CUSTOMER_IO_SDK_KEY
    ? AnalyticsBrowser.load({ writeKey: environment.VITE_CUSTOMER_IO_SDK_KEY })
    : null;
